export default "/images/zh.png?9d3d05d16d9bda8494896b6eff4c45b6";